var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    staticClass: "pt-10 sm-md:pt-0"
  }, [_c('loading-overlay', {
    attrs: {
      "wait-for": _vm.processing || _vm.personaLoading
    }
  }), _vm._v(" "), _vm.memberProfile ? _c('persona-section', {
    attrs: {
      "member-profile": _vm.memberProfile,
      "standalone": true
    },
    on: {
      "loading": loading => _vm.personaLoading = loading,
      "cancel": _vm.dismiss,
      "complete": _vm.onPersonaComplete,
      "error": error => _vm.onError(error)
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };